import apiClient from './ApiClient';

export class PaymentRepository {
	constructor(client) {
		this.client = client;
		this.basePath = '/api/payments';
	}

	async recordManual(payload) {
		return this.client.post(`${this.basePath}/manual`, payload);
	}
}

export default new PaymentRepository(apiClient);
